// loyaltylion app lock functionlity //
function renderRewards(data, customerTierID) {
    const rewards = data.rewards;
    const tiers = data.tier_configuration.tiers;

    rewards.forEach((reward) => {
        // 1️⃣ Variant for current tier
        const currentTierVariant = reward.variants.find((v) => v.tier_id === customerTierID);

        if (currentTierVariant?.enabled === true) return;

        const enabledVariants = reward.variants.filter(v => v.enabled === true);

        if (!enabledVariants.length) return;

        // Sort by tier number (lowest first)
        enabledVariants.sort((a, b) => a.tier_id - b.tier_id);

        // Pick the first unlock tier
        const nextUnlockVariant = enabledVariants[0];

        const unlockTier = tiers.find((t) => t.id === nextUnlockVariant.tier_id);
        console.log('Display Variant:', reward);


        const card = document.createElement('div');
        card.className = 'lion-reward-item lion-reward-item--customer locked';
        card.setAttribute('data-reward-id', reward.id);

        card.innerHTML = `
        <div class="lion-reward-item__content">

        ${
            reward?.properties?.product
            ? `
            <img
            src="${reward.properties.product.image_url}"
            style="object-fit: cover; height: 42px; width: 42px; border-radius: 4px;"
            >
        `
            : `
            <div class="lion-reward-item__icon lion-icon lion-icon__reward
            lion-icon__reward--${reward.kind.replace(/_/g, '-')}">
            </div>
        `
        }

        <div class="lion-reward-item__title">${nextUnlockVariant.title || reward.title}</div>
        <p>${reward?.properties?.discount && reward.properties?.product   ? reward.properties.discount.formatted + ' off' : '' } ${nextUnlockVariant.cost_text || ''}</p>

        ${unlockTier?.name ? `
            <div class="reward-overlay">
            <span class="reward-overlay-text">
                Unlocks in: <strong>${unlockTier?.name} TIER</strong>
            </span>
            </div>
        ` : ''}

        ${
            reward?.properties?.product?.handle
            ? `
            <div class="lion-reward-item__links">
            <div class="lion-reward-item__more-info-url--external-link">
                <a href="https://alyvewellness.com/products/${reward.properties.product.handle}">
                View product
                </a>
            </div>
            </div>
        `
            : ''
        }

        </div>
        `;
        const observer = new MutationObserver(() => {
        const grid = document.querySelector(
            '[data-lion-integrated-page-section-kind="redeem"] .lion-rewards-list'
        );

        if (grid) {
            grid.appendChild(card); // your logic here

            observer.disconnect(); // 🔥 destroy observer after first run
        }
        });

        observer.observe(document.body, {
        childList: true,
        subtree: true
        });

    });
}
function attachRewardCard(card) {

    const observer = new MutationObserver(() => {
        const grid = document.querySelector(
            '[data-lion-integrated-page-section-kind="redeem"] .lion-rewards-list'
        );

        if (!grid) return;


        // 🧩 Add your custom card
        if (!grid.contains(card)) {
            grid.appendChild(card);
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}


function renderRewardsForNewUser(data) {
    const rewards = data.rewards;
    const tiers = data.tier_configuration.tiers;

    rewards.forEach((reward) => {

        const enabledVariants = reward.variants.filter(v => v.enabled === true);
        if (!enabledVariants.length) return;

        enabledVariants.sort((a, b) => a.tier_id - b.tier_id);

        const nextUnlockVariant = enabledVariants[0];
        const unlockTier = tiers.find(t => t.id === nextUnlockVariant.tier_id);

        if (unlockTier?.name === 'Explorer') return;
        
        const card = document.createElement('div');
        card.className = 'lion-reward-item lion-reward-item--customer locked';
        card.setAttribute('data-reward-id', reward.id);

        card.innerHTML = `
        <div class="lion-reward-item__content">

        ${
            reward?.properties?.product
            ? `<img src="${reward.properties.product.image_url}" style="object-fit:cover;height:42px;width:42px;border-radius:4px;">`
            : `<div class="lion-reward-item__icon lion-icon lion-icon__reward lion-icon__reward--${reward.kind.replace(/_/g, '-')}"></div>`
        }

        <div class="lion-reward-item__title">
            ${nextUnlockVariant.title || reward.title}
        </div>

        <p>
            ${reward?.properties?.discount && reward.properties?.product ? reward.properties.discount.formatted + ' off' : ''} 
            ${nextUnlockVariant.cost_text || ''}
        </p>

        ${unlockTier?.name ? `
            <div class="reward-overlay">
                <span class="reward-overlay-text">
                    Unlocks in: <strong>${unlockTier.name} TIER</strong>
                </span>
            </div>
        ` : ''}

        ${
            reward?.properties?.product?.handle
            ? `
            <div class="lion-reward-item__links">
                <div class="lion-reward-item__more-info-url--external-link">
                    <a href="https://alyvewellness.com/products/${reward.properties.product.handle}">
                        View product
                    </a>
                </div>
            </div>
            `
            : ''
        }

        </div>
        `;
        attachRewardCard(card);
    });
}

// Replace these with your actual values
const SITE_ID = '56793';
const SDK_TOKEN = 'pat_31b87484a94e088a6451173c4b5ceef5';

const customersoptions = {
    method: 'GET',
    headers: {
        Authorization: `Bearer ${SDK_TOKEN}`,
        'Content-Type': 'application/json',
    },
};
if ( !window.customer_id.startsWith("guest-")) {
    fetch(
    `https://api.loyaltylion.com/headless/2025-06/${SITE_ID}/customers/${window.customer_id}?channel=web`,
    customersoptions
    )
    .then((res) => {
        if (!res.ok) {
            return res.json().then((err) => {
            throw new Error(`HTTP ${res.status}: ${JSON.stringify(err)}`);
            });
        }
        return res.json();
    })
    .then((data) => {
        const userTierId = data.customer?.tier_membership?.tier_id;
        renderRewards(data?.configuration, userTierId);
    })
    .catch((err) => {
        let errorCode = 'unknown_error';
        const jsonPart = err.message.split(': ').slice(1).join(': ');
        const parsed = JSON.parse(jsonPart);
        errorCode = parsed?.error?.code || errorCode;

        if (errorCode === 'not_found') {
            const TARGET_SELECTOR = '[data-lion-integrated-page-section-kind="redeem"] .lion-rewards-list';
            const CARD_SELECTOR = '.lion-reward-item__content';

            const observer = new MutationObserver(() => {
                const grid = document.querySelector(TARGET_SELECTOR);
                if (!grid) return;

                const cards = grid.querySelectorAll(CARD_SELECTOR);
                if (!cards.length) return;

                cards.forEach(card => {
                const parent = card.parentElement;

                if (!parent || parent.classList.contains('locked')) return;

                parent.classList.add('locked');

                if (card.querySelector('.reward-overlay')) return;

                const overlay = document.createElement('div');
                overlay.className = 'reward-overlay';
                overlay.innerHTML = `
                    <span class="reward-overlay-text">
                    Unlocks in: <strong>Explorer TIER</strong>
                    </span>
                `;

                card.appendChild(overlay);
                });

                // Once everything is handled, stop observing
                observer.disconnect();
            });

            observer.observe(document.body, { childList: true, subtree: true });
        }

    });
}else{
    fetch(
    `https://api.loyaltylion.com/headless/2025-06/${SITE_ID}/configuration?channel=web`,
    customersoptions
    )
    .then((res) => {
        if (!res.ok) {
            return res.json().then((err) => {
            throw new Error(`HTTP ${res.status}: ${JSON.stringify(err)}`);
            });
        }
        return res.json();
    })
    .then((data) => {
       renderRewardsForNewUser(data); 
    })
}